import { Grid, DialogActions, Button, DialogContent } from '@mui/material'
import SaveIcon from '@mui/icons-material/Save'
import ReactQuill from 'react-quill'
import { useState } from 'react'
import PropTypes from 'prop-types'
import eventBus from '../../../../lib/eventBus'
import { useDispatch } from 'react-redux'
import { closePopup } from '../../../../store/popupsSlice'

const ExaminationComponentNoteFactory = ({ id, comment }) => {
  const dispatch = useDispatch()
  const [value, setValue] = useState(comment)

  const submit = () => {
    eventBus.dispatch('examination-component-comment', { comment: value, id })
    dispatch(closePopup('examination-component-note-factory'))
  }

  return (
    <>
      <DialogContent dividers={true}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <ReactQuill value={value} onChange={setValue} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={submit}
          startIcon={<SaveIcon />}
          variant="contained"
          color="primary"
          type="submit"
        >
          Zapisz
        </Button>
      </DialogActions>
    </>
  )
}

ExaminationComponentNoteFactory.propTypes = {
  comment: PropTypes.string,
  id: PropTypes.any,
}

export default ExaminationComponentNoteFactory
